/* eslint-disable */
import { useEffect, useState } from 'react';
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { useAppDispatch } from '../app/hooks';

import {
    fetchUserDataFailure,
    fetchUserDataInit,
    fetchUserDataSuccess,
    resetUserData
} from '../app/authSlice';
import { getUserSettingsThunk, resetUserSettings } from '../app/userSlice';
import { LoginType } from '../api-types/models/LoginDto';
import { useIsAuthenticated } from '@azure/msal-react';

const useAmplifyAuth = () => {
    const [triggerFetch, setTriggerFetch] = useState(false);
    const dispatch = useAppDispatch();
    const isAuthenticated = useIsAuthenticated();

    useEffect(() => {
        let isMounted = true;

        const fetchUserData = async () => {
            if (isMounted) {
                dispatch(fetchUserDataInit());
                try {
                    const session = await fetchAuthSession();
                    const user = await getCurrentUser();

                    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                    if (session && user) {
                        // Transform to match expected CognitoUser structure
                        const cognitoUser = {
                            username: user.username,
                            userId: user.userId,
                            signInDetails: user.signInDetails,
                            challengeName: '',
                            attributes: {
                                email: user.username
                            },
                            signInUserSession: {
                                accessToken: {
                                    payload:
                                        session.tokens?.accessToken?.payload ??
                                        {}
                                }
                            }
                        };

                        dispatch(fetchUserDataSuccess(cognitoUser));

                        const userGroups = session.tokens?.accessToken?.payload[
                            'cognito:groups'
                        ] as string[] | undefined;

                        if (
                            userGroups &&
                            !userGroups.includes(LoginType.BRUNCH) &&
                            !userGroups.includes(LoginType.COACH)
                        ) {
                            dispatch(getUserSettingsThunk());
                        }
                    }
                } catch (error) {
                    if (isAuthenticated) {
                        dispatch(getUserSettingsThunk());
                    } else {
                        dispatch(resetUserData());
                        dispatch(fetchUserDataFailure());
                    }
                }
            }
        };

        const HubListener = () => {
            Hub.listen('auth', (data) => {
                onAuthEvent(data);
            });
        };

        const onAuthEvent = (data: any) => {
            switch (data.payload.event) {
                case 'signedIn':
                    if (isMounted) {
                        setTriggerFetch(true);
                        console.log('signed in');
                    }
                    break;
                default:
                    return;
            }
        };

        HubListener();
        fetchUserData().catch((error) => {
            console.log('Error fetching user data ', error);
        });

        return () => {
            // In v6, Hub listeners are cleaned up differently
            // The listen method returns an unsubscribe function
            isMounted = false;
        };
    }, [dispatch, triggerFetch, isAuthenticated]);

    const handleSignout = async () => {
        try {
            console.log('signed out');
            await signOut();
            setTriggerFetch(false);
            dispatch(resetUserData());
            dispatch(resetUserSettings());
        } catch (error) {
            console.error('Error signing out user ', error);
        }
    };

    return { handleSignout };
};

export default useAmplifyAuth;
